
import Vue from "vue";
import { PropType } from "vue";
import { welcomeToTheMoonMixins } from "@/mixins/welcomeToTheMoonMixins";
import { WelcomeToTheMoonPlay } from "@/types";

export default Vue.extend({
  name: "WelcomeToTheMoonScoresByDate",
  mixins: [welcomeToTheMoonMixins],
  props: {
    plays: {
      type: Array as PropType<WelcomeToTheMoonPlay[]>,
      required: true,
      default: [],
    },
    mainPlayerId: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    sortedPlays(): WelcomeToTheMoonPlay[] {
      return this.plays.slice(0).reverse();
    },
  },
  methods: {
    automaLevelLitteral(value: number | undefined): string {
      switch (value) {
        case 2:
          return "Alexei";
        case 3:
          return "Margaret";
        case 4:
          return "Franklin";
        case 5:
          return "Sergei";
        case 6:
          return "Stéphanie";
        case 7:
          return "Thomas";
        case 8:
          return "Peggy";
        case 1:
        default:
          return "Katherine";
      }
    },
  },
});
